export const handleScroll = () => {
  const header = document.querySelector('header');
  if (!header) return;

  header.style.top = '0';
};

handleScroll();
